import type { SegmentKind } from '@/domains/pages/shared/segment-kind';
import type { SegmentScopeView } from '@/domains/pages/shared/segment-scope-tabs';
import type { NebulyPageKey } from '@/domains/pages/types';

export function parseAiSpendView(value: string | null): SegmentScopeView {
  if (value === 'team' || value === 'market' || value === 'tenure') return value;
  return 'all';
}

export function pageKeyToSpendSegmentKind(pageKey: NebulyPageKey): SegmentKind | null {
  if (pageKey === 'ai-spend-team') return 'team';
  if (pageKey === 'ai-spend-market') return 'market';
  if (pageKey === 'ai-spend-tenure') return 'tenure';
  return null;
}
